import { onJSentinelAny } from "../core/events";

export function attachConsoleLogger() {
  return onJSentinelAny((m) => {
    const ts = new Date().toISOString();
    if (m.type === "script.ok") console.info(`[JSentinel ${ts}] OK`, m.data.key);
    else if (m.type === "script.mismatch") console.warn(`[JSentinel ${ts}] MISMATCH`, m.data);
    else if (m.type === "scan.complete") console.log(`[JSentinel ${ts}] Scan`, m.data);
  });
}
